/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import ResourceEnum from 'astro/enum/resource';

import Cass from 'astro/server/zone/cass';
import Attributes from 'astro/server/zone/attributes';

import * as Coords from 'shared/geo/coords';


export default class
{
  constructor (cass, planet)
  {
    this.planet = planet;

    this.cass = new Cass(cass, this);
    this.attributes = new Attributes(this);
  }


  setup ()
  {
  }


  getAttributes ()
  {
    return this.attributes;
  }


  getSector ()
  {
    return this.planet.getSectors().getOne(this.cass.getSector());
  }


  getPlanet ()
  {
    return this.planet;
  }


  getInteractionsTo ()
  {
    return this.getPlanet().getInteractions().getInteractionsTo(this.getCoords());
  }


  getInteractionsFrom ()
  {
    return this.getPlanet().getInteractions().getInteractionsFrom(this.getCoords());
  }


  getProjectilesTo ()
  {
    return this.getPlanet().getProjectiles().getProjectilesTo(this.getCoords());
  }


  getProjectilesFrom ()
  {
    return this.getPlanet().getProjectiles().getProjectilesFrom(this.getCoords());
  }


  getBuilding ()
  {
    return this.getPlanet().getBuilding(this.getID());
  }


  getResourceName ()
  {
    if (this.getCass().getResource() == null)
    {
      return '';
    }

    switch (this.getCass().getResource().type)
    {
      case ResourceEnum.Carbon:   return 'Carbon';
      case ResourceEnum.Silicon:  return 'Silicon';
      case ResourceEnum.Hydrogen: return 'Hydrogen';
    }
  }


  getUnit ()
  {
    return this.getPlanet().getUnit(this.getID());
  }


  getEntity ()
  {
    return this.getPlanet().getEntities().getEntity(this.getID());
  }


  getLocation (resolver = this.planet)
  {
    return resolver.getLocation(this.getCass().getCoords());
  }


  getUser (resolver = this.planet)
  {
    return resolver.getUser(this.getUserID());
  }


  getType ()
  {
    return this.cass;
  }


  getCass ()
  {
    return this.cass;
  }


  getCoords ()
  {
    return this.getCass().getCoords();
  }


  getRelativeCoords ()
  {
    return Coords.subtract(this.getCoords(), this.planet.getCoords());
  }


  getID ()
  {
    return this.getCass().getID();
  }


  getUserID ()
  {
    return this.getCass().getUser();
  }


  isLocal ()
  {
    return true;
  }


  isPlatform ()
  {
    return false;
  }


}
